export default __webpack_public_path__ + "static/media/Gallery2.91febaff.jpg";